module.exports = __webpack_public_path__ + "c07c0003a2c9821533583e7b72f6a150.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/app/xBodyComponent/assets/xbodyBG.jpg
// module id = 1051
// module chunks = 3